import PropTypes from 'prop-types';
import currencyExchangeProp from './currencyExchangeProp';

export const WALLET_TYPE = {
  FIAT: 'fiat',
  CRYPTO: 'crypto',
  COINS: 'coins',
  COUPONS: 'coupons',
  VOUCHERS: 'vouchers',
  CHARITY: 'charity', // Total charity coins in the organization
  NEO_DEAL: 'neo_deal', // Neo Deal Fund (Only for internal use of neofin)
  NEO_POOL: 'neo_pool', // Neo Pool Fund (Only for internal use of neofin)
};

export const CRYPTO_FARM = {
  HASH_RATE: 'hashrate',
  MINERS_ONLINE: 'minersOnline',
  POWER_USAGE: 'powerUsage',
  MINERS_TOTAL: 'minersTotal',
};

export const CRYPTO_FARM_ORDER = {
  hashrate: 0,
  minersOnline: 1,
  powerUsage: 2,
  minersTotal: 3,
};

const propType = {
  type: PropTypes.oneOf(Object.values(WALLET_TYPE)).isRequired,
  currency: PropTypes.string,
  balance: PropTypes.string,
  available: PropTypes.string,
  totalPayouts: PropTypes.string,
  totalPayments: PropTypes.string,
  userPriceBalance: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape(currencyExchangeProp.propType),
  ]),
  userPriceAvailable: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape(currencyExchangeProp.propType),
  ]),
  currencyInfo: PropTypes.shape({
    name: PropTypes.string,
    symbol: PropTypes.string,
    symbol_native: PropTypes.string,
    icon: PropTypes.string,
  }),
  // Wallet types this wallet may be converted into (BRAVON-6268). Drives the
  // Exchange button — empty/undefined means no conversion is allowed.
  allowedConversions: PropTypes.arrayOf(PropTypes.string),
};

export default { propType };
